var map = {
	"./featured-blogs.de-CH.json": 1270,
	"./featured-blogs.de-DE.json": 1271,
	"./featured-blogs.en-CA.json": 1272,
	"./featured-blogs.en-GB.json": 1273,
	"./featured-blogs.en-IN.json": 1274,
	"./featured-blogs.en-ME.json": 1275,
	"./featured-blogs.en-US.json": 1276,
	"./featured-blogs.es-EM.json": 1277,
	"./featured-blogs.es-ES.json": 1278,
	"./featured-blogs.fr-BE.json": 1279,
	"./featured-blogs.fr-CA.json": 1280,
	"./featured-blogs.fr-CH.json": 1281,
	"./featured-blogs.nl-BE.json": 1282,
	"./featured-blogs.nl-NL.json": 1283,
	"./featured-blogs.pl-PL.json": 1284,
	"./featured-blogs.pt-BR.json": 1285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1269;